<template>
  <div>
    我是独立页面{{name}}
  </div>
</template>

<script>
  export default{
    data(){
      return {
        name:'sfsfsf'
      }
    }
  }
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/statistics/index.vue